<template>
    <div class="row partner-list">
        <div class="col-md-3 col-12" v-for="partner in partners">
            <input :id="partner.name" type="radio" :value="partner" v-model="partnerSelection" checked>
            <label :for="partner.name" class="w-100 h-100">
                <partner :partner="partner"></partner>
            </label>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'partners'
    ],
    data() {
        return {
            'partnerSelection': this.partners[0]
        }
    },
    watch: {
        partnerSelection: function () {
            this.$emit('selectedPartnerChanged', this.partnerSelection)
        }
    }
}
</script>

<style scoped lang="scss">
.partner-list {
    input[type="radio"] {
        appearance: none;

        &:checked + label {
            .card {
                box-shadow: 0 0 2px 2px rgba(188, 146, 104, 0.6);
            }
        }

        + label .card {
            cursor: pointer;
        }
    }
}
</style>

